import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
import { DeferredMount } from '../components/DeferredMount';
// First batch — sections that appear right after the hero. Mount them as soon
// as the user scrolls past the hero so the JS chunks fetch just-in-time.
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
// Second batch — far below the fold. Only fetch when the user scrolls close
// to it. Keeps initial JS payload tiny.
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-268">
      <div data-id="element-269">
        <HeroSection data-id="element-270" />

        {/* Mount first batch on first user interaction or when scrolled near */}
        <DeferredMount rootMargin="800px" minHeight={300} mountOnInteraction data-id="element-271">
          <Suspense fallback={null} data-id="element-272">
            <TrustBar data-id="element-273" />
            <ContrastSection data-id="element-274" />
            <ForWhomSection data-id="element-275" />
            <BenefitsSection data-id="element-276" />
            <ContentPreview data-id="element-277" />
            <BonusSection data-id="element-278" />
            <PricingSection data-id="element-279" />
          </Suspense>
        </DeferredMount>

        {/* Second batch: deeper below the fold, only mount when nearby */}
        <DeferredMount rootMargin="600px" minHeight={600} data-id="element-280">
          <Suspense fallback={null} data-id="element-281">
            <GuaranteeSection data-id="element-282" />
            <TestimonialsSection data-id="element-283" />
            <ExpertSection data-id="element-284" />
            <FAQSection data-id="element-285" />
            <Footer data-id="element-286" />
            <SocialProofPopup data-id="element-287" />
            <StickyCTA data-id="element-288" />
          </Suspense>
        </DeferredMount>
      </div>
    </main>;
}